exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-77928a14]:deep(.el-header){padding:0 12px}[data-v-77928a14]:deep(.el-main){padding:6px}\n", ""]);

// exports
